import { Auth, useAuthedRequest } from "shared/@auth/Auth";
import { useCallback, useState } from "react";
import { useQuery, useMutation } from "react-query";

export const useHome = () => {
  const { makeAuthedRequest } = Auth.useContainer();

  const { data, loading, error, refetch } = useQuery(
    ["syncData"],
    () =>
      makeAuthedRequest(`/dreamstream/sync/diamonds/0/0`, {
        method: "GET",
      }).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      }),
    {
      refetchInterval: 10 * 1000,
    },
    { staleTime: 0 }
  );

  const { data: syncDiamonds } = useQuery(["syncDiamonds"], () =>
    makeAuthedRequest(
      `/membership/lookup/pin?pin=4&limit=null&filters=&sort=name-asc`,
      {
        method: "GET",
      }
    ).then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    })
  );

  const cancelSyncPut = useMutation(["cancelSync"], (syncId) =>
    makeAuthedRequest(`/dreamstream/sync/complete`, {
      method: "PUT",
      body: JSON.stringify(syncId),
    }).then(async (res) => {
      if (res.ok) {
        return await res.json();
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    })
  );

  const sync = useCallback(
    async (diamonds) => {
      return makeAuthedRequest("/dreamstream/sync", {
        method: "POST",
        body: JSON.stringify({
          type: "diamonds",
          diamonds: diamonds,
        }),
      }).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const json = await res.json();
          throw new Error(json.message);
        }
      });
    },
    [makeAuthedRequest]
  );

  return {
    data,
    error,
    loading,
    sync,
    refetch,
    syncDiamonds,
    cancelSyncPut,
  };
};
